"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withReduxForm;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));
/* eslint-disable react/prop-types */


function withReduxForm(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(_class, _Component);

    function _class(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, _class);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).call(this, props));
      _this.fieldRef = _react["default"].createRef();
      return _this;
    }

    (0, _createClass2["default"])(_class, [{
      key: "getErrorMessage",
      value: function getErrorMessage() {
        var _this$props = this.props,
            meta = _this$props.meta,
            error = _this$props.error;

        if (meta) {
          var touched = meta.touched,
              submitFailed = meta.submitFailed,
              metaError = meta.error;

          if ((touched || submitFailed) && metaError) {
            return metaError;
          }
        }

        return error;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.fieldRef.current.focus();
      }
    }, {
      key: "click",
      value: function click() {
        this.fieldRef.current.click();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.fieldRef.current.blur();
      }
    }, {
      key: "reset",
      value: function reset() {
        this.fieldRef.current.reset();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            error = _this$props2.error,
            input = _this$props2.input,
            meta = _this$props2.meta,
            rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["error", "input", "meta"]);
        return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, rest, input, {
          error: this.getErrorMessage(),
          ref: this.fieldRef
        }));
      }
    }]);
    return _class;
  }(_react.Component);
}